/**
 *
 * @param {Object} obj
 * @param {string|number} property
 * @return {boolean}
 */
export function safeHasOwnProperty(obj, property) {
  return obj && Object.prototype.hasOwnProperty.call(obj, property)
}

/**
 *
 * @param {object} obj
 * @param {string} key
 * @param {*} defaultValue
 * @return {*}
 */
export function getObjKey(obj, key, defaultValue = null) {
  let val = defaultValue

  if (safeHasOwnProperty(obj, key)) {
    val = obj[key]
  } else if (
    typeof obj === 'object'
    && key.indexOf('.') >= 0
  ) {
    const parts = key.split('.')
    while (parts.length > 0) {
      key = parts.shift()
      if (safeHasOwnProperty(obj, key)) {
        if (parts.length > 0) {
          obj = obj[key]
          if (typeof obj !== 'object') {
            break
          }
        } else {
          val = obj[key]
        }
      } else {
        break
      }
    }
  }

  return val
}

/**
 * @param {object} obj
 * @param {string} key
 * @return {boolean}
 */
export function objFieldExists(obj, key) {
  let yes = !!obj

  if (yes && !safeHasOwnProperty(obj, key)) {
    if (key.indexOf('.') >= 0) {
      const parts = key.split('.')
      while (parts.length > 0) {
        key = parts.shift()
        if (safeHasOwnProperty(obj, key)) {
          obj = obj[key]
        } else {
          yes = false
          break
        }
      }
    } else {
      yes = false
    }
  }

  return yes
}

/**
 *
 * @param {Object} obj
 * @param {function} predicate
 * @param {number} maxDepth
 * @return {string[]}
 */
export function objCrawler(obj, predicate, maxDepth = 5) {
  const results = []

  if (typeof obj === 'object' && maxDepth > 0) {
    for (const objKey in obj) {
      if (safeHasOwnProperty(obj, objKey)) {
        if (typeof obj[objKey] === 'object' && maxDepth > 1) {
          objCrawler(obj[objKey], predicate, maxDepth - 1)
            .forEach((subKey) => {
              results.push(objKey + '.' + subKey)
            })
        } else if (predicate(obj[objKey])) {
          results.push(objKey)
        }
      }
    }
  }

  return results
}
